import { UserProfileDTO } from '@shared/clientTypes/DTOs/UserDTO';
import { getUserLocation } from 'apps/agora/src/utils/helpers';
import ProfileAsideBiography from './ProfileAsideBiography';
import ProfileAsideContact from './ProfileAsideContact';
import ProfileAsideLinkedin from './ProfileAsideLinkedin';
import ProfileAsideMentorCv from './ProfileAsideMentorCv';
import ProfileAsideHeader from './ProfileAsideHeader';
import ProfileAsideLocation from './ProfileAsideLocation/ProfileAsideLocation';
import ProfileAsideParent from './ProfileAsideParent';
import ProfileAsideStrategist from './ProfileAsideStrategist';
import ProfileAsideWhatsApp from './ProfileAsideWhatsApp';

interface ProfileAsideProps {
  userProfile?: Partial<UserProfileDTO>;
  hasEditPermissions: boolean;
  isMentorProfile: boolean;
}
const ProfileAside = (props: ProfileAsideProps) => {
  const { userProfile, hasEditPermissions, isMentorProfile } = props;

  return (
    <aside className="flex flex-col gap-4 p-6 bg-surfaceBackground rounded-lg tablet:w-2/5 laptop:w-1/3">
      <ProfileAsideHeader
        name={userProfile?.fullName ?? ''}
        profileImg={userProfile?.avatar ?? ''}
        studentType={userProfile?.studentType ?? ''}
        major={userProfile?.major?.name ?? ''}
        createdAt={userProfile?.createdAt ?? ''}
        enrollments={userProfile?.enrollments ?? []}
        hasEditPermissions={hasEditPermissions}
        googleDriveLink={userProfile?.googleDrive}
        isMentorProfile={isMentorProfile}
        graduationYear={userProfile?.graduationYear}
      />

      <ProfileAsideContact
        firstName={userProfile?.firstName ?? ''}
        lastName={userProfile?.lastName ?? ''}
        email={userProfile?.email ?? ''}
        phone={userProfile?.phoneNumber}
        userId={userProfile?._id ?? ''}
        hasEditPermissions={hasEditPermissions}
        isMentorProfile={isMentorProfile}
      />

      {!isMentorProfile && (
        <ProfileAsideWhatsApp whatsappGroupLink={userProfile?.whatsappGroupLink ?? ''} />
      )}

      {isMentorProfile ? (
        <>
          <ProfileAsideBiography
            biography={userProfile?.mentorData?.biography ?? ''}
            userId={userProfile?._id ?? ''}
            hasEditPermissions={hasEditPermissions}
          />
          <ProfileAsideLinkedin
            linkedin={userProfile?.mentorData?.linkedin ?? ''}
            userId={userProfile?._id ?? ''}
            hasEditPermissions={hasEditPermissions}
          />
          <ProfileAsideMentorCv
            hasCv={!!userProfile?.mentorData?.cv}
            userId={userProfile?._id ?? ''}
            hasEditPermissions={hasEditPermissions}
          />
        </>
      ) : (
        <ProfileAsideParent
          email={userProfile?.parentData?.email ?? ''}
          phone={userProfile?.parentData?.phoneNumber}
          name={userProfile?.parentData?.fullName ?? ''}
          userId={userProfile?._id ?? ''}
          hasEditPermissions={hasEditPermissions}
        />
      )}

      {!isMentorProfile && userProfile?.educationStrategist && (
        <ProfileAsideStrategist
          name={
            userProfile.educationStrategist.fullName ??
            `${userProfile.educationStrategist.firstName ?? ''} ${
              userProfile.educationStrategist.lastName ?? ''
            }`.trim()
          }
          email={userProfile.educationStrategist.email ?? ''}
          phone={userProfile.educationStrategist.phoneNumber}
        />
      )}
      <ProfileAsideLocation
        location={getUserLocation(userProfile)}
        city={userProfile?.city ?? ''}
        cityRef={userProfile?.cityRef}
        country={userProfile?.country ?? ''}
        timezone={userProfile?.timezone ?? ''}
        languages={userProfile?.spokenLanguages ?? []}
        userId={userProfile?._id ?? ''}
        hasEditPermissions={hasEditPermissions}
      />
    </aside>
  );
};

export default ProfileAside;
